import clsx from 'clsx';

import {ProtectedImage} from '../Protected';

const sizes = {
  xs: 'size-4',
  sm: 'size-5',
  md: 'size-6',
  lg: 'size-7',
  xl: 'size-8',
  '2xl': 'size-12',
  '3xl': 'size-16',
};

type Props = Omit<
  React.ImgHTMLAttributes<HTMLImageElement>,
  'src' | 'onLoad' | 'onError'
> & {
  name: string;
  src?: string;
  size?: keyof typeof sizes;
};
export function Avatar({
  className,
  src,
  name,
  size,
  ...props
}: Props): React.JSX.Element {
  const s = size || 'md';

  return src ? (
    <ProtectedImage
      alt={name}
      title={name}
      {...props}
      src={src}
      className={clsx(className, sizes[s], 'inline-block rounded-full')}
    />
  ) : (
    <span
      title={name}
      className={clsx(
        className,
        sizes[s],
        'inline-block overflow-hidden rounded-full bg-slate6 dark:bg-slate9'
      )}
    >
      <svg
        fill="currentColor"
        viewBox="0 0 24 24"
        className="mx-[-5%] size-[110%] text-slate3 dark:text-slate5"
      >
        <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
      </svg>
    </span>
  );
}

Avatar.displayName = 'Avatar';
